import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

function getRiskLevel(row: FulfillmentGroupData): string {
  if (!row.risk) {
    return "";
  }
  if (
    row.risk?.assessments.some((assessment) => assessment.riskLevel === "HIGH")
  ) {
    return "High";
  } else if (
    row.risk?.assessments.some(
      (assessment) => assessment.riskLevel === "MEDIUM",
    )
  ) {
    return "Medium";
  } else {
    return "";
  }
}

export const FraudRiskCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Fraud risk",
    cell: (row) => {
      return getRiskLevel(row);
    },
  };
